import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./CrearTipoPlanillaStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {TipoPlanillaRegistro} from "./tipoPlanilla-registro";
import TipoPlanillaService from "services/TipoPlanillaService";
import { notification } from "antd";

const CrearTipoPlanillaPage=()=>{
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [tipoPlanillaAtom]=useAtom(atoms.tipoPlanilla);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetornarListarTipoPlanillas=()=>{
        history.push("/tipoPlanilla");
    }
    const onClickBtnCancelarModal=()=>{
        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal = async ()=>{
        try {
            setLoading(true);
            const _tipoPlanilla= await TipoPlanillaService.insertar(tipoPlanillaAtom);
            setLoading(false);
            cerrarModalConfirmacion();
            history.push("/tipoPlanilla");
            
        } catch (error) {
            console.error(error);
            cerrarModalConfirmacion();
            notification.error({
                message:"Error",
                description:error.response.data.mensaje});
            
        }finally{
            setLoading(false);
        }

    }
    return(
        <Container titulo="Crear Tipo Planilla" onClickRetornar={onClickRetornarListarTipoPlanillas}>
         <TipoPlanillaRegistro/>
         <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de guardar el Tipo Planilla? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />
        </Container>
    )

}
export default CrearTipoPlanillaPage;